/* eslint-disable react/display-name */
import { useField } from "@unform/core";
import { forwardRef, useEffect, useRef } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormContext, useFormState } from "react-hook-form";

import { htmlToText, transformEditorStateIntoData } from "Helpers/Util";

import HelpText from "../Form/Input/Components/HelpText";
import * as S from "./styles";

export const TextEditor = forwardRef(
  (
    {
      editorState,
      setEditorState,
      label,
      includeLink = true,
      required,
      disabled,
      ...rest
    },
    ref,
  ) => {
    const inputRef = useRef(null);

    const options = ["inline", "blockType", "list"];

    if (includeLink) options.push("link");

    const { fieldName } = rest?.name ? useField(rest?.name) : {};

    const methods = useFormContext();
    const { setFocus, control } = methods ? methods : {};

    const { errors } = methods
      ? useFormState({
          control,
        })
      : {};

    useEffect(() => {
      if (errors && errors[fieldName]) {
        setFocus(fieldName);
      }
    }, [errors]);

    useEffect(() => {
      if (rest.onChange && editorState && !disabled) {
        const html = transformEditorStateIntoData(editorState);

        const text = htmlToText(html);

        rest.onChange({
          target: {
            ...rest,
            value: text,
          },
        });
      }
    }, [editorState]);

    return (
      <S.TextEditorContainer disabled={disabled}>
        <p>
          {label} {required && <S.RequiredDot />}
        </p>
        <Editor
          ref={ref ?? inputRef}
          editorState={editorState}
          onEditorStateChange={(e) => !disabled && setEditorState(e)}
          toolbar={{
            options,
            inline: {
              options: ["bold", "italic", "underline", "strikethrough"],
            },
          }}
          disabled={disabled}
        />
        {errors && errors[fieldName] ? (
          <HelpText id={fieldName} text={errors[fieldName]?.message} />
        ) : null}
      </S.TextEditorContainer>
    );
  },
);
